let config = {}

config.ip = 'bell.tagan.ru';
config.port = 3000;

module.exports = config;


// WEBPACK FOOTER //
// ./src/config/index.js